// @flow
import * as React from 'react';
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
import {LocalizedParagraph, useLocalized} from 'components/Localized';
import Logo from 'components/Logo';
import GuideMessageCenter from 'components/GuideMessageCenter';
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer'
import {BackgroundImage} from 'components/Image';
//import {useLayoutState} from 'components/Layout';
//import ButtonNextPage from 'components/ButtonNextPage';
import SoundToggleButton from 'components/SoundToggleButton';
import {isTouch} from 'components/Responsive';


type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
  onSkip: () => void,
};



export default function ChargingStationB(props: Props): React.Element<any> {
  const localized = useLocalized();
  //const layoutState = useLayoutState();
  const [showGuideTime, setShowGuideTime] = React.useState(0);
  const timer1 = React.useRef(null);
  const timer2 = React.useRef(null);
  const timer3 = React.useRef(null);
  const timer4 = React.useRef(null);
  const {onNext} = props;
  const [scrollThumb, setScrollThumb] = React.useState(null);
  const refScrollThumb = React.useCallback(node => {
    setScrollThumb(node);
  }, [setScrollThumb]);

  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseBChargingStationDragPluginPage();
  },[]);

  const handleNext = React.useCallback(() => {
    onNext();
  }, [onNext])

  const [clicked, setClicked] = React.useState(false);

  React.useEffect(()=>{
    VideoUtils.loadB02_1();
  }, []);

  const clickHandler = React.useCallback( ()=>{
    console.log('click');
    window.tagManager.chargingStationDragPluginDragPluginLinkClick();
    VideoUtils.play();
    VideoUtils.onEnd(handleNext);
    setClicked(true);

    timer1.current = VideoUtils.setTimeout(() => setShowGuideTime(2), 2000);
    timer2.current = VideoUtils.setTimeout(() => setShowGuideTime(4), 4000);
    timer3.current = VideoUtils.setTimeout(() => setShowGuideTime(9), 9000);
    timer4.current = VideoUtils.setTimeout(() => setShowGuideTime(11), 11000);

  }, [handleNext]);


  const refScrollAreaBG = React.useCallback(dragArea => {
      if (dragArea !== null && scrollThumb !== null) {
        //chargingStationScrollThumb

        let range = isTouch()?{min:2, max:170}:{min:5, max:300};
        window.makeHorizontalDraggable(scrollThumb, dragArea, range, 
          function(){
          },
          function(x, relX){
          },
          function(x, relX){

            if (relX >= range.max - 10 || relX >= range.max * 0.8 ) {
              scrollThumb.style.left = range.max + "px";
              clickHandler();
            } else {
              scrollThumb.style.left = range.min + "px";
            }


          },
         );
        scrollThumb.style.left = range.min + "px";

      } else {

      }

  }, [scrollThumb,  clickHandler]);

  const key = "ChargingStationB_buttonSpot";

  React.useEffect(()=>{
    return ()=>{
      VideoUtils.clearTimeout(timer1.current);
      VideoUtils.clearTimeout(timer2.current);
      VideoUtils.clearTimeout(timer3.current);
      VideoUtils.clearTimeout(timer4.current);
    };

  }, []);
  const refCallback = isTouch() ? VideoUtils.CreateAddPointCallback(key, 0.29411764705882354, 0.4170846633226934) : 
    VideoUtils.CreateAddPointCallback(key, 0.4, 0.56)
  ;

  return (
    <main>
      <GuideMessageCenter show={showGuideTime >= 2 && showGuideTime < 4} textKey="driving_b02_charging3_210307_001" />
      <GuideMessageCenter show={showGuideTime >= 9 && showGuideTime < 11} textKey="driving_b02_charging3_210307_002" />


      {isTouch() === false && <DummySpot id="DummySpotPC" ref={refCallback} style={{visibility: clicked?"hidden":""}} onClick={() => {
        //clickHandler();
      }} >
        <GuideMessageRight>
          <LocalizedParagraph {...localized.driving_b02_charging_011} />
        </GuideMessageRight>
        {isTouch() === false && <ScrollAreaBG ref={refScrollAreaBG} source="./driving-zone/b/img-b-02-charging-bg.png">
          <ScrollThumb ref={refScrollThumb} source="./driving-zone/b/btn-b-02-charging.png" />
        </ScrollAreaBG>}
        
      </DummySpot>}

      {isTouch() === true && <DummySpotMobile id="DummySpotMobile" ref={refCallback} style={{visibility: clicked?"hidden":""}} onClick={() => {
        clickHandler();
      }} >
        <GuideMessageRight>
          <LocalizedParagraph {...localized.driving_b02_charging_011} />
        </GuideMessageRight>
        <SpotLine source="./driving-zone/b/img-pligin-spot-line.png" />
        <SpotPlus source="./driving-zone/b/img-plugin-plus.png" />
        <SpotGuide source="./driving-zone/b/img-touch-finger.png" className="effectBlinkSoft" />

      </DummySpotMobile>}

      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />
      

      <Logo />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_B02b" />
    </main>
  );
}

const DummySpot = styled.div`
position: absolute;
left: 0px;
top: 0px;

`;

const DummySpotMobile = styled.button`
position: absolute;
left: 0px;
top: 0px;

`;

const SpotGuide = styled(BackgroundImage)`
  position: absolute;
left: -15px;
top: 19px;
width: 45px;
height: 74px;
`;

const SpotPlus = styled(BackgroundImage)`
  position: absolute;
left: -17px;
top: -17px;
width: 35px;
height: 35px;

`;
const SpotLine = styled(BackgroundImage)`
  position: absolute;
left: -50px;
top: -50px;
width: 100px;
height: 100px;
pointer-events:auto;

`;

const GuideMessageRight = styled.div`
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile || isTouch() ? 65  : -74)}px;
  top: ${(props) => (props.theme.layout.mobile  || isTouch()? 18 : -190)}px;
  width: ${(props) => (props.theme.layout.mobile || isTouch() ? 229 : 445)}px;
  height: ${(props) => (props.theme.layout.mobile || isTouch() ? 65 : 105)}px;
  p {
    text-align: ${(props) => ( (props.theme.layout.mobile || isTouch() ) ? "left"  : "center")};
  }
  display: flex;
  align-items: ${(props) => (props.theme.layout.mobile ? "left" : "center")};;
  justify-content: ${(props) => (props.theme.layout.mobile ? "left" : "center")};;

`;

const ScrollAreaBG = styled(BackgroundImage)`
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 65 + 11 : -54)}px;
  top: ${(props) => (props.theme.layout.mobile ? 0 : -55)}px;
  width: ${(props) => (props.theme.layout.mobile ? 229 : 405)}px;
  height: ${(props) => (props.theme.layout.mobile ? 62 : 110)}px;
  pointer-events: auto;

`;

const ScrollThumb = styled(BackgroundImage)`
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 2 : 5)}px;
  top: ${(props) => (props.theme.layout.mobile ? 2 : 5)}px;
  width: ${(props) => (props.theme.layout.mobile ? 62 : 108)}px;
  height: ${(props) => (props.theme.layout.mobile ? 58 : 100)}px;
`;
